import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import {
  IconNotificationFilled,
  IconNotificationOutlined,
} from '@prisjakt/ui/icon';
import { ButtonIcon } from '@prisjakt/ui/button';
import { ButtonText, Tooltip, Button } from './styles';

export const AlertButton: React.FC<AlertButtonProps> = ({
  isActive,
  onClick,
}) => {
  const { t } = useAppContext();

  return (
    <Tooltip title={t('product', 'action-button.alert-tooltip')} zIndex={1}>
      <Button ariaLabel={t('product', 'alert.create-button')} onClick={onClick}>
        <ButtonIcon>
          {isActive ? <IconNotificationFilled /> : <IconNotificationOutlined />}
        </ButtonIcon>
        <ButtonText>{t('product', 'alert.create-button')}</ButtonText>
      </Button>
    </Tooltip>
  );
};

interface AlertButtonProps {
  isActive: boolean;
  onClick?: () => void;
}
